import Gauge from "components/Guage/Guage";
import Loader from "components/Spinners/Loader";
import { TRASH_ICON } from "components/Icons";
import { formatString } from "utils/index";

const CartItemCard = ({ data, loading, handleRemove }) => {
  const product = data?.productData || {};

  const formattedPrice = product?.price
    ?.toFixed(2)
    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const subtitle =
    product?.discipline ||
    product?.category ||
    product?.seatDiscipline ||
    "";

  const score = Math.round(data?.score || 0);

  const onRemove = () => {
    handleRemove(product?.sk);
  };

  return (
    <div className="w-full p-4 border border-[#D4DEED] rounded-[18px] bg-white flex flex-col md:flex-row md:items-stretch gap-3 sm:gap-7">
      {/* Left: image in inner card */}
      <div className="shrink-0 w-full md:w-[250px]">
        <div className="w-full h-[220px] md:h-full border border-[#E4E7EC] rounded-[18px] bg-white flex items-center justify-center overflow-hidden">
          <img
            src={product?.photo}
            alt={product?.productTitle || "saddle"}
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Right: content */}
      <div className="flex-1 flex flex-col justify-between mt-3 md:mt-0">
        {/* Top: title, subtitle, price + stock */}
        <div>
          <p className="text-[15px] sm:text-[28px] font-[Montserrat] font-semibold leading-[100%] tracking-[-2%] text-[#000000]">
            {product?.productTitle}
          </p>

          {subtitle && (
            <p className="text-[12px] sm:text-[18px] leading-[100%] tracking-[-2%] text-[#6A6A6A] font-medium font-[Montserrat]">
              {formatString(subtitle)}
            </p>
          )}

          <div className="mt-[13px] flex items-center gap-[18px]">
            <p className="text-[16px] sm:text-[28px] font-[Montserrat] font-semibold text-[#111827]">
              ${formattedPrice}
            </p>
          </div>
        </div>

        {/* Bottom: gauge on left, remove on right */}
        <div className="mt-3 flex items-end justify-between">
          <Gauge
            style={{
              fontFamily: "Montserrat",
              fontWeight: "bold",
            }}
            score={score}
            className="w-[170px] sm:w-[286px] h-[90px] sm:h-[141px]"
          />

          <div className="flex items-center justify-center gap-1 cursor-pointer select-none">
            {loading ? (
              <Loader filledColor="#ff5a5f" />
            ) : (
              <div onClick={onRemove} className="flex items-center gap-1">
                <TRASH_ICON className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                <p className="text-[11px] sm:text-[14px] font-medium font-[Montserrat] leading-[100%] tracking-[-2%] text-[#CF3434]">
                  Remove
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItemCard;
